import { render, staticRenderFns } from "./mallLoader.vue?vue&type=template&id=a65e5864&scoped=true&"
import script from "./mallLoader.vue?vue&type=script&lang=js&"
export * from "./mallLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a65e5864",
  null
  
)

export default component.exports